import TimerFactory from './timer'

const middlewareFactory = (Timer) => function middleware(storeAPI) {
    return function wrapDispatch(next) {
        return function handleAction(action) {
            // Do anything here: pass the action onwards with next(action),
            // or restart the pipeline with storeAPI.dispatch(action)
            // Can also use storeAPI.getState() here

            const nextAction = next(action)

            try {
                Timer.handleAction(action, storeAPI)
            } catch (error) {
                /* eslint-disable-next-line no-console */
                console.error(error)
            }

            return nextAction
        }
    }
}

function initialize({
    reducerName,
} = {}) {
    const Timer = TimerFactory({
        reducerName,
    })
    const middleware = middlewareFactory(Timer)

    return {
        middleware,

        reducer: Timer.reducer,
        reducerName: Timer.reducerName,

        set: Timer.creators.set,
        start: Timer.creators.start,
        stop: Timer.creators.stop,
        // reset: Timer.creators.reset,

        // startTime: Timer.selectors.startTime,
        // duration: Timer.selectors.duration,
        // timeRemaining: Timer.selectors.timeRemaining,
        // onDoneAction: Timer.selectors.onDoneAction,
        isRunning: Timer.selectors.isRunning,
    }
}

export default initialize
